import SelectValues from '../objects/SelectValues';

export interface InnerCourse {
    id:number;
    course:string
}


export default class Course extends SelectValues {
    private _id: number;
    private _name: string;

    constructor(course:InnerCourse) {
        super();

        this._id = course.id;
        this._name = course.course;
    }

    get name(): string {
        return this._name;
    }
    get id(): number {
        return this._id;
    }
}
